export default "__VITE_ASSET__D0F0PCl6__"